export enum SectionStatus {
    PENDING="0",
    DRAFT="10",
    CREATED="20",
    IN_PROGRESS="30",
    COMPLETED="40",
    DELETED="50"
}//TODO: Manoj 17042020: Review